import { PORTFOLIO_PAGE_ROUTE } from "#components/PortfolioPage/portfolioPageRoute"
import {
  type Resource,
  RESOURCES,
  USER_ACTIONS,
  type UserAction,
} from "#customTypes/composedTypes/authTypes"

import { ROUTES } from "./routes"

export type RoutePermissionRequirement = {
  resource: Resource
  action: UserAction
}

export const ROUTE_PERMISSION_REQUIREMENTS: Record<
  string,
  RoutePermissionRequirement
> = {
  [ROUTES.PROJECTS]: {
    resource: RESOURCES.PROJECTS_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.CURRICULUM_PLANS]: {
    resource: RESOURCES.CURRICULUM_PLANS_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.EVALUATIONS]: {
    resource: RESOURCES.EVALUATIONS_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.USERS]: {
    resource: RESOURCES.USERS_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.SETTINGS]: {
    resource: RESOURCES.SETTINGS_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.FRONT_DESK_VIEW]: {
    resource: RESOURCES.FRONT_DESK_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.TEACHER_VIEW]: {
    resource: RESOURCES.TEACHER_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.STUDENTS]: {
    resource: RESOURCES.STUDENTS_PAGE,
    action: USER_ACTIONS.READ,
  },
  // Keyed by the route PATTERN — RoutePermissionGate is handed the pattern,
  // not the matched pathname. STUDENT.READ (not STUDENTS_PAGE) because the
  // page is also reached from the teacher and front-desk attendance rows.
  [PORTFOLIO_PAGE_ROUTE]: {
    resource: RESOURCES.STUDENT,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.CLASSES]: {
    resource: RESOURCES.CLASSES_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.MAKEUPS]: {
    resource: RESOURCES.MAKEUPS_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.QUALITY_CHECK]: {
    resource: RESOURCES.QUALITY_CHECK_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.STANDOUT_REVIEW]: {
    resource: RESOURCES.STANDOUT_REVIEW_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.TRYOUTS]: {
    resource: RESOURCES.TRYOUTS_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.TAGS]: {
    resource: RESOURCES.TAGS_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.SEMESTERS]: {
    resource: RESOURCES.SEMESTERS_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.TEST]: {
    resource: RESOURCES.TEST_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.PROFILE]: {
    resource: RESOURCES.PROFILE_PAGE,
    action: USER_ACTIONS.READ,
  },
  [ROUTES.AUTH_TEST]: {
    resource: RESOURCES.AUTH_TEST_PAGE,
    action: USER_ACTIONS.READ,
  },
  "/eval-debug": {
    resource: RESOURCES.TEST_PAGE,
    action: USER_ACTIONS.READ,
  },
  "/notification-debug": {
    resource: RESOURCES.TEST_PAGE,
    action: USER_ACTIONS.READ,
  },
  "/portfolio-debug": {
    resource: RESOURCES.TEST_PAGE,
    action: USER_ACTIONS.READ,
  },
  "/artwork-wall-debug": {
    resource: RESOURCES.TEST_PAGE,
    action: USER_ACTIONS.READ,
  },
}
